import { configureStore } from '@reduxjs/toolkit';

import rootReducer from './reducer';

export const store = configureStore({
	reducer: rootReducer
});

export type AppStore = typeof store;
export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export { default as rootReducer, initialState } from './reducer';

export * from './api';

export * from './slices/forwarders';
export * from './slices/sources';
export * from './slices/ui';

export * from './selectors';
